import { render, staticRenderFns } from "./BaseEmptyState.vue?vue&type=template&id=2a563c63&scoped=true&"
import script from "./BaseEmptyState.vue?vue&type=script&lang=js&"
export * from "./BaseEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./BaseEmptyState.vue?vue&type=style&index=0&id=2a563c63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a563c63",
  null
  
)

export default component.exports